import st from "@/styles/Ui.module.scss";
import ChevroneIcon from "@/svg/ChevroneIcon.tsx";

import Select from "@mui/joy/Select";
import React, {ReactNode, useRef} from "react";
// import {textfield_sx} from "@/utils/mui_sx.ts";
// import {TextField} from "@mui/material";
interface Props {
    children: ReactNode
    selected: any
    handleChange?(e:any):void,
    name?:string
    error?:boolean
}

const StandartSelector:React.FC<Props> = (props:Props) => {
    const chevrone = useRef<any>(null)
    const  {
        children,
        selected,
        handleChange,
        name,
        // error
    } =  props
    
    
    return (
        <Select
            className={st.selector}
            value={selected}
            // error={error}
            name={name || ""}
            onChange={handleChange}
            onListboxOpenChange={(x) => {
                if (chevrone.current) {
                    if (x) {
                        chevrone.current.classList.add(st.open)
                    } else {
                        chevrone.current.classList.remove(st.open)
                    }
                }
            }}
            indicator={
                <div ref={chevrone} className={st.indicator}>
                    <ChevroneIcon/>
                </div>
            }
            sx={{
                width: "100%",
                minHeight: "48px",
                backgroundColor: "transparent",
                border: "1px solid #7C837D",
                color: "#7C837D",
                borderRadius: '12px', // You can adjust the border radius
                '& .MuiInputBase-root': {
                    padding: '8px',  // Add padding to the Select's input
                    fontSize: '14px',
                },
                '&:hover': {
                    backgroundColor: "transparent", // You can add hover styles here
                },
            }}
            
            slotProps={{
                listbox: {
                    sx: {
                        width: "100%",
                        maxHeight: 300,
                        overflow: 'auto',
                    },
                },
            }}
        >
            {children}
        </Select>
        
        
        
    )
}

export default StandartSelector